import React from 'react';
import { useDispatch } from 'react-redux';

import { MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';
import { toggleNoticeModal } from '@/src/reducers/project/tagFileWorkstream/tagFileWorkstream.actions';

const NoticeModal = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(toggleNoticeModal(false));
  };

  return (
    <ModalPopup
      id={'removeWorkstreamNotice'}
      modalType={MODAL_TYPE.danger}
      title={'Remove Tagged Workstream?'}
      message={
        'The file selected is currently tagged to a workstream and related task that requires this file as an attachment. To proceed, please go to related task and untag the file/s first.'
      }
      onClose={handleClose}
      onConfirm={handleClose}
      confirmBtn={{ label: 'Okay' }}
    />
  );
};

export default NoticeModal;
